<div id='stepper-container' *ngIf="stepper">
  <nav mat-tab-nav-bar class="stepper">
    <a mat-tab-link class="step" *ngFor="let step of stepper"  [routerLink]="step.state" [disabled]="step.enable" routerLinkActive="active"
    queryParamsHandling="merge" [queryParams]="step.queryParams" id="id-{{step.name}}" >
      <div class="step-icon">{{ step.name.split('')[step.name.split('').indexOf(' ') + 1] }}</div>
      <div class="step-label">{{ step.name | translate }}</div>
    </a>
  </nav>
</div>